import * as React from 'react';
import SearchResultItem from './SearchResultItem';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { SearchSchoolDocument } from '../types';
import { LocationIcon } from './common';

export interface SearchResultsProps {
    searchResults: SearchSchoolDocument[];
    searchText: string;
    onChangeSearchText: (text: string) => void;
}

const SearchResults = (props: SearchResultsProps) => {
    const { searchResults: items, searchText, onChangeSearchText } = props;
    const groups = _(items)
        .groupBy(s => s.destinationId)
        .map((value, key) => ({ destinationId: key, schools: value }))
        .value();

    const searchResultItems =
        groups.map((g: { destinationId: string; schools: SearchSchoolDocument[] }) => {
            return (
                <CSSTransition
                    key={`search-result-group-${g.destinationId}`}
                    classNames="searchResultGroup"
                    timeout={{ enter: 500, exit: 300 }}
                >
                    <div className="searchResultGroup">
                        <div className="searchResultLocation">
                            <LocationIcon />
                            <Link to={`/destination/${g.destinationId}`}>
                                &nbsp;{g.schools[0].destinationName}
                            </Link>
                        </div>
                        <div>
                            {
                                g.schools.map((school) => {
                                    return (
                                        <SearchResultItem
                                            key={`search-result-school-${school.id}`}
                                            id={school.id}
                                            name={school.name}
                                        />
                                    );
                                })}
                        </div>
                    </div>
                </CSSTransition>
            );
        });

    return (
        <div className="flex-col searchResultBody">
            <input
                className="inputText"
                type="search"
                value={searchText}
                onChange={event => onChangeSearchText(event.target.value)}
                placeholder="search"
                aria-label="Search Box"
            />
            <TransitionGroup
                className="searchResults"
            >
                {searchResultItems}
            </TransitionGroup>
        </div>
    );
};

export default SearchResults;